class VideoIntersectionInsert extends HTMLElement {
  constructor() {
    super();
    this._observer = null;
    this._isPlaying = false;
    this._loaded = false;
    this._playedOnce = false;
    this._onlyLoad = false;
  }

  connectedCallback() {
    const videoHtml = this.dataset.src;
    if (!videoHtml) return;
    this._observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        const visibleHeight = entry.intersectionRect.height;
        this._onlyLoad = this.hasAttribute("onlyLoad");
        if (this.hasAttribute("once") && this._playedOnce ) return;
        if (visibleHeight >= 100 && !this._loaded) {
          const videoDiv = document.createElement("div");
          videoDiv.innerHTML = videoHtml;
          this._video = videoDiv.querySelector("video");
          this.querySelectorAll("img").forEach((b) => (b.style.visibility = "hidden"));
          this.appendChild(this._video);
          this._loaded = true;
          if(this._onlyLoad) return
          this._video.play().catch(() => {});
          this._isPlaying = true;
          this._video.addEventListener("ended", () => {
            if (this.hasAttribute("once")) {
              this._playedOnce = true;
              this._observer?.disconnect();
              this._video.pause();
            }
          });
        }
        if (visibleHeight >= 100 && !this._isPlaying && !this._playedOnce && !this._onlyLoad) {
          this._video.play().catch(() => {});
          this._isPlaying = true;
        } else if (visibleHeight < 100 && this._isPlaying && !this.hasAttribute("once")) {
          this._video.pause();
          this._isPlaying = false;
        }
      },
      {
        root: null,
        threshold: Array.from({ length: 101 }, (_, i) => i / 100),
      }
    );

    this._observer.observe(this);
  }

  disconnectedCallback() {
    this._observer?.disconnect();
  }
}

if (!customElements.get("video-intersection-insert")) {
  customElements.define("video-intersection-insert", VideoIntersectionInsert);
}


class productMediaSwiper extends HTMLElement {
  connectedCallback() {
    document.addEventListener('DOMContentLoaded', function() {
      const swiperEl = document.querySelector('.product-media-swiper .swiper');
      const prevEl = document.querySelector('.product-media-swiper .swiper-button-prev');
      const nextEl = document.querySelector('.product-media-swiper .swiper-button-next');
      const swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        observer: true,   
        observeParents: true,
        on: {
          slideChange(swiper) {
            // 1) 取当前索引
            const idx = swiper.params.loop ? swiper.realIndex : swiper.activeIndex;

            // 2) 找到所有缩略图 slide
            const thumbs = document.querySelectorAll(
              '.main-product .xo-product-info-media-carousel__thumb-slide'
            );

            // 3) 先清空 active
            thumbs.forEach(el => el.classList.remove('active'));

            // 4) 给对应索引加 active
            const target = thumbs[idx];
            if (target) target.classList.add('active'); // 你用 active 也行
          }
        },
        navigation: {
          prevEl,
          nextEl
        },
      });

      $(".xo-product-thumbnails .xo-product-info-media-carousel__thumb-slide").click(function() {
        $(this).addClass("active").siblings().removeClass("active");
        const idx = $(this).index();
        swiper.slideTo(idx);
      });
    });
  }
}
if (!customElements.get("product-media-swiper")) {
  customElements.define("product-media-swiper", productMediaSwiper);
}


class ProductInfoDesc extends HTMLElement {
  connectedCallback() {
    function moveIndicator(indicator, target) {
      const rect = target.getBoundingClientRect();
      const parentRect = target.parentElement.getBoundingClientRect();
      const offsetLeft = rect.left - parentRect.left;
      indicator.style.width = rect.width + "px";
      indicator.style.transform = `translateX(${offsetLeft}px)`;
    }
    document.addEventListener('DOMContentLoaded', () => {
      const swiperEl = this.querySelector('.swiper');
      const indicator = this.querySelector(".scroll-bar");
      const swiper = new Swiper(swiperEl, {
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        allowTouchMove: false
      });
      const $labels = $(this).find('.product-desc-label'); 
      $labels.click(function() {
        if($(this).hasClass('active')) return;
        $(this).addClass('active').siblings().removeClass('active');
        const idx = $(this).index();
        swiper.slideTo(idx);
        moveIndicator(indicator, this);
      })
      moveIndicator(indicator, $labels.eq(0)[0]);
    });
  }
}
if (!customElements.get("product-info-desc")) {
  customElements.define("product-info-desc", ProductInfoDesc);
}


class ProductSticky extends HTMLElement {
  constructor() {
    super();
    this.stickyForm = null;
    this.observer = null;
    this.addButton = null;
    this.header = null;
    this.handleResize = this.updateStickyPosition.bind(this);
  }

  connectedCallback() {
    document.addEventListener('DOMContentLoaded', () => {
      $(".product-sticky-inner .form-centrer span").on("click", function () {
        $(".product-sticky-inner .form-centrer span").removeClass("active");
        $(this).addClass("active");
        // 获取 data-view 值
        const anchorKey = $(this).data("view");
        if (!anchorKey) return;
        // 找到目标 section
        let $target = null;
        if(anchorKey == 'reviews') {
          $target = $(".trustify-review-box");
        } else {
          $target = $(".anchor-target." + anchorKey);
        }

        if (!$target.length) return;

        // 找 header 元素并计算高度
        const $header = $(".header"); // 根据你实际主题修改
        const headerHeight = $header.length ? $header.outerHeight() : 0;

        // 计算滚动位置
        const offsetTop = $target.offset().top - headerHeight - 10; // 减去 header + 一点间距

        // 平滑滚动
        $("html, body").animate({ scrollTop: offsetTop }, 500);
      });


      this.stickyForm = this.querySelector('.product-sticky-form');
      this.addButton = document.querySelector('.xo-product-info-content-form') || document.querySelector('.main-product');
      this.header = document.querySelector('.header');
      if (!this.stickyForm || !this.addButton || !this.header) return;
      this.observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        const headerBottom = this.header.getBoundingClientRect().bottom;
        const addButtonBottom = this.addButton.getBoundingClientRect().bottom;
        console.log(addButtonBottom)
        if (!entry.isIntersecting && addButtonBottom < 0) {
          this.stickyForm.classList.remove("hidden-sticky");
          this.updateStickyPosition();
        } else {
          this.stickyForm.classList.add("hidden-sticky");
        }
      }, {
        root: null,
        threshold: 0,
      });

      this.observer.observe(this.addButton);
      window.addEventListener('resize', this.handleResize);
    });
  }

  updateStickyPosition() {
    if (!this.stickyForm || !this.header) return;
    const isVisible = !this.stickyForm.classList.contains('hidden-sticky');
    if (!isVisible) return;
    const headerHeight = this.header.offsetHeight - 1;
    const header = document.querySelector('.header_all');
    this.stickyForm.style.top = `-1px`; //`${headerHeight}px`
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    window.removeEventListener('resize', this.handleResize);
  }
}

customElements.define('product-sticky', ProductSticky);